import {
  Badge,
  Button,
  Flex,
  Table,
  Tbody,
  Text,
  Th,
  Thead,
  Tr,
  Td,
  useColorModeValue,
  Select,
  IconButton,
} from '@chakra-ui/react'
import Card from 'components/Card/Card.js'
import CardBody from 'components/Card/CardBody.js'
import CardHeader from 'components/Card/CardHeader.js'
import { SearchBar } from 'components/Navbars/SearchBar/SearchBar'
import React, { useCallback, useState, useMemo } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { GET_WORKSHEETS, DELETE_WORKSHEET } from 'store/worksheets'

const STATUS = [
  { value: 'true', label: 'เปิดใช้งาน' },
  { value: 'false', label: 'ปิดใช้งาน' },
]

const TableData = ({ title, captions, data }) => {
  const textColor = useColorModeValue('gray.700', 'white')
  const bgButton = useColorModeValue(
    'linear-gradient(81.62deg, #313860 2.25%, #151928 79.87%)',
    'gray.800'
  )
  const history = useHistory()
  const dispatch = useDispatch()
  const [selectedStatus, setSelectedStatus] = useState('true')

  const routeAdd = () => history.push('/admin/worksheets/add')

  const fetchData = useCallback((searchInput) => {
    dispatch(GET_WORKSHEETS(`?search=${searchInput}`))
  }, [dispatch])

  const handleStatusChange = useCallback((e) => {
    setSelectedStatus(e.target.value)
  }, [])

  const handleDelete = useCallback((id) => {
    if (window.confirm('ต้องการลบใบงานนี้หรือไม่?')) {
      dispatch(DELETE_WORKSHEET(id)).then(() => dispatch(GET_WORKSHEETS('')))
    }
  }, [dispatch])

  const filteredData = useMemo(() => {
    if (!selectedStatus) return data
    return data.filter(row => String(row.status) === selectedStatus)
  }, [data, selectedStatus])

  return (
    <Card overflowX={{ sm: 'scroll', xl: 'hidden' }}>
      <CardHeader>
        <Flex justify='space-between' align='center' minHeight='60px' w='100%'>
          <Text fontSize='lg' color={textColor} fontWeight='bold'>
            {title}
          </Text>
          <SearchBar fetchData={fetchData} />
          <Select
            value={selectedStatus}
            onChange={handleStatusChange}
            width='200px'
            bg={useColorModeValue('white', 'gray.700')}
          >
            {STATUS.map((s) => (
              <option key={s.value} value={s.value}>{s.label}</option>
            ))}
          </Select>
          <Button bg={bgButton} color='white' fontSize='xs' variant='no-hover' onClick={routeAdd}>
            เพิ่มใบงาน
          </Button>
        </Flex>
      </CardHeader>
      <CardBody>
        <Table variant='simple' color={textColor}>
          <Thead>
            <Tr my='.8rem' pl='0px' color='gray.400'>
              {captions.map((caption, idx) => (
                <Th color='gray.400' key={idx} ps={idx === 0 ? '0px' : null}>
                  {caption}
                </Th>
              ))}
            </Tr>
          </Thead>
          <Tbody>
            {filteredData.map((row) => (
              <Tr key={row.id}>
                <Td ps='0px'>
                  <Text fontWeight='bold' fontSize='sm'>{row.name}</Text>
                </Td>
                <Td><Text fontSize='sm' noOfLines={2}>{row.description}</Text></Td>
                <Td><Text fontSize='sm'>{row.subject}</Text></Td>
                <Td><Text fontSize='sm'>{row.class}</Text></Td>
                <Td>
                  <Badge colorScheme={row.is_free ? 'green' : 'orange'}>
                    {row.is_free ? 'ฟรี' : 'เสียเงิน'}
                  </Badge>
                </Td>
                <Td>
                  <Badge colorScheme={row.status ? 'teal' : 'red'}>
                    {row.status ? 'เปิด' : 'ปิด'}
                  </Badge>
                </Td>
                <Td>
                  <Button
                    size='sm'
                    colorScheme='teal'
                    variant='outline'
                    onClick={() => history.push(`/admin/worksheets/edit/${row.id}`)}
                  >
                    แก้ไข
                  </Button>
                </Td>
                <Td>
                  <Button
                    size='sm'
                    colorScheme='red'
                    variant='outline'
                    onClick={() => handleDelete(row.id)}
                  >
                    ลบ
                  </Button>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </CardBody>
    </Card>
  )
}

export default TableData
